import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import Button from '../../atoms/Button';
import InputWrapper from '../../atoms/InputWrapper';
import FilterGroup from '../../molecules/filter/FilterGroup';
import FilterInputItem from '../../molecules/FilterInputItem';
import FilterSelectItem from '../../molecules/FilterSelectItem';
import Cross from '../../atoms/icons/Cross';
const StyledCross = styled(Cross) `
    width: 12px;
    height: 12px;
`;
const userOptions = [
    { value: 'active', label: 'Actief' },
    { value: 'inactive', label: 'Inactief' },
    { value: 'invited', label: 'Uitgenodigd' },
];
const Filters = ({ filters, setFilters }) => {
    const { t } = useTranslation();
    const setFilter = (name, value) => {
        setFilters({ ...filters, [name]: value });
    };
    return (_jsxs(FilterGroup, { children: [_jsx(FilterInputItem, { label: t('user.name'), placeholder: t('user.name_filter_placeholder'), width: "160px", type: "text", value: "", setFilter: setFilter, name: 'dossier_number' }), _jsx(FilterInputItem, { label: t('user.email'), placeholder: t('user.email_filter_placeholder'), width: "160px", value: "", setFilter: setFilter, name: 'debtor_name' }), _jsx(FilterSelectItem, { label: t('user.status'), placeholder: "Kies een status", width: "160px", options: userOptions, value: "", setFilter: setFilter, name: 'status' }), _jsx(InputWrapper, { children: _jsx(Button, { primary: true, icon: _jsx(StyledCross, {}), children: _jsx(Trans, { i18nKey: "users.clear_filters" }) }) })] }));
};
export default Filters;
